import { useMemo } from 'react';

import { useAppSelector } from '@/shared/hooks';

import { reportsModel } from '@/entities/reports';

import type { FullHeadMprSliceRecordViewsByTileID } from '../config';
import { makeFullHeadMprSliceRecordViews } from '../lib';

export const useToothFullHeadMprSliceRecords = (
  toothID: string,
): FullHeadMprSliceRecordViewsByTileID => {
  const slices = useAppSelector(
    reportsModel.selectors.selectFullHeadMprSlicesByToothID(toothID),
  );

  return useMemo(
    () => makeFullHeadMprSliceRecordViews({ slices, toothID }),
    [slices, toothID],
  );
};
